export const ACTION_HREFS = {
    messages: "/dashboard/messages/organ",
    exp_settings: "/dashboard/exp-settings",
    surveys: "/dashboard/surveys",
    customer_club: "/dashboard/customer-club",
    profile: "/dashboard/profile",
    report: "/dashboard/report",
    incentives: "/dashboard/customer-club?tab=points",
};

const AI_ERROR_CODES = {
    "report.ai_suggestions_failed": "ai.actions.error",
    "report.ai_not_configured": "ai.actions.not.configured",
    "report.company_required": "ai.actions.company.required",
    "report.ai_need_data": "ai.actions.need.data",
};

function firstDetail(detail) {
    if (Array.isArray(detail)) return detail[0];
    return detail;
}

export function hrefForAction(actionKey, href) {
    if (href) return href;
    return ACTION_HREFS[actionKey] || ACTION_HREFS.report;
}

export function formatSuggestionTime(value) {
    if (!value) return "";
    const match = String(value).match(/^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2})/);
    if (match) return `${match[1]} ${match[2]}`;
    return String(value);
}

export function normalizeSuggestion(item, index = 0) {
    if (!item || typeof item !== "object") return null;
    const title = String(item.title || "").trim();
    const body = String(item.body || "").trim();
    if (!title || !body) return null;
    const actionKey = item.action_key || "report";
    return {
        id: String(item.id || `suggestion-${index + 1}`),
        title,
        body,
        rationale: String(item.rationale || "").trim(),
        priority: ["high", "medium", "low"].includes(item.priority)
            ? item.priority
            : "medium",
        category: item.category || "operations",
        action_key: actionKey,
        href: hrefForAction(actionKey, item.href),
    };
}

export function normalizeHistoryEntry(item, index = 0) {
    if (!item || typeof item !== "object") return null;
    const suggestions = Array.isArray(item.suggestions)
        ? item.suggestions.map(normalizeSuggestion).filter(Boolean)
        : [];
    const generatedAt =
        item.jalali_generated_at || item.generated_at || null;
    const headline = String(item.headline || "").trim();
    if (!suggestions.length && !headline && !generatedAt) return null;
    return {
        id: String(item.id || `history-${index + 1}`),
        headline,
        suggestions,
        generatedAt,
    };
}

export function normalizeSuggestionPayload(payload) {
    const rows = Array.isArray(payload?.suggestions)
        ? payload.suggestions
        : [];
    const history = Array.isArray(payload?.history) ? payload.history : [];
    return {
        headline: String(payload?.headline || "").trim(),
        suggestions: rows.map(normalizeSuggestion).filter(Boolean),
        generatedAt:
            payload?.jalali_generated_at || payload?.generated_at || null,
        canGenerate: Boolean(payload?.can_generate),
        history: history.map(normalizeHistoryEntry).filter(Boolean),
    };
}

export function messageFromSuggestionError(error, t) {
    const data = error?.response?.data || {};
    if (data.code && AI_ERROR_CODES[data.code]) {
        return t(AI_ERROR_CODES[data.code]);
    }
    const detail = firstDetail(data.detail);
    if (typeof detail === "string" && /[آ-ی]/.test(detail)) {
        return detail;
    }
    return t("ai.actions.error");
}
